<template>
    <button type="button" class="btn btn-success btn-block" @click="download" hidden>Descargar</button>
</template>
<style>
</style>

<script>

    export default {
        inject: [],
        props: [
            'recordings',
            'selectedRows',
            'getAudio',
            'searchedFilters',
            'getResultMessage',
            'showErrorModal'
        ],
        data() {
            return {
            }
        },
        methods: {
            download() {
                if (this.recordings.length > 0){
                    this.$emit('update-loading', true);

                    if (this.recordings.length == 1 || this.selectedRows && this.selectedRows.length == 1) {
                        let recording = null;
                        if (this.recordings.length == 1) recording = this.recordings[0];
                        else recording =  this.selectedRows[0];

                        let [id_interaction, recording_id] = [recording.id_interaction, recording.id];

                        this.getAudio(recording_id).
                            then((audio_file) => {
                                if(audio_file){
                                        let audio = new Audio("data:audio/x-wav;base64, " + audio_file);
                                        audio.load();
                                        audio.addEventListener('loadeddata', (event) => {
                                            this.downloadFile(event.target.src, 'grabación ' + id_interaction + '.mp3');
                                        });
                                    } else {
                                        this.showErrorModal('"descargar"', id_interaction);
                                    }
                                    this.$emit('update-loading', false);
                                });
                    } else this.selectedRows ? this.downloadAudiosAsZip(this.selectedRows) : this.downloadAudiosAsZip(this.recordings);
                }
            },
            downloadFile(url, fileName){
                var element = document.createElement('a');
                element.setAttribute('href', url);
                element.setAttribute('download', fileName);

                element.style.display = 'none';
                document.body.appendChild(element);

                element.click();
                document.body.removeChild(element);
            },
            downloadAudiosAsZip(recordings){

                let idsToZip = [];
                recordings.forEach(recording => {
                    idsToZip.push(recording.id);
                });

                let nameZip = '';
                if((!this.selectedRows || this.selectedRows && this.selectedRows.length == 0) && this.searchedFilters && Object.entries(this.searchedFilters).length === 0 ){
                    nameZip = 'últimas diez grabaciones';
                } else {
                    nameZip = 'grabaciones';
                    // let existValues = false;
                    nameZip = nameZip + this.getResultMessage(this.searchedFilters, true);
                }
                nameZip += '.zip';

                this.downloadAudiosZip(idsToZip)
                .then((audiosAsZip) => {
                    if(audiosAsZip) {
                        const url = window.URL.createObjectURL(new Blob([audiosAsZip]));
                        this.downloadFile(url, nameZip);

                        } else this.showErrorModal('"descargar"', null, true);
                        this.$emit('update-loading', false);
                    });
            },
            downloadAudiosZip(idsToZip){
                console.log(idsToZip);
                // return axios.get(`api/recordings/download/${btoa(idsToZip)}`, { responseType: 'blob'})
                //     .then(response => { if (response.status === 200 && response.data) return response.data;})
                //     .catch(errors => { return null; });
            }
        }
    }
</script>
